import { render, staticRenderFns } from "./ProjectCreationExitModal.vue?vue&type=template&id=4e859d6d"
import script from "./ProjectCreationExitModal.vue?vue&type=script&lang=ts"
export * from "./ProjectCreationExitModal.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCreationExitModal.vue?vue&type=style&index=0&id=4e859d6d&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports